import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'General configuration',
  attributeName: 'liveGlobalSetup',
  fields: [
    {
      attributeName: 'eventType1',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Live event type',
      label: 'Type event',
      default:'OTT',
      disabled:true,
      helpText: 'Show type of event',
      visibleWhen:{"field":"deploymentType","value":'ott'},
    },
    {

      attributeName: 'deploymentGPU',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'GPU enabled',
      label: 'GPU Enabled',
      required: true,
      default:false,
      helpText: 'With GPU enabled, you can create CCR (cloud control rooms with more than 8 cameras)',
      errorText: '',
      disabled:true,
      visibleWhen:[{"field":"deploymentGPU","value":true},],
    },
    {
      attributeName: 'eventType2',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Live event type',
      label: 'Type event',
      disabled:true,
      default:'LOW LATENCY',
      helpText: 'Show type of event',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Live event name',
      label: 'Name',
      required: true,
      helpText: 'Valid formats: Letters, numbers, "-", "_", and white spaces starting with letter',
      errorText: '',
    },
    {
      attributeName: 'deployment',
      helpText: 'Deployment',
      type: FormInputTypes.SELECT,
      label: 'Deployment',
      placeholder: 'Please enter to add Deployment code...',
      multiple: false,
      url: 'livedeploymentslist',
      urlByField: {
        field: 'deploymentType',
        map: {
          ott: 'livedeploymentslist/ott',
          lowLatency: 'livedeploymentslist/lowLatency',
        },
      },
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      fieldValue:'coderegionvalue',
      fieldName:'coderegiontext',
      fieldDisabled:'coderegionDisable',
      fieldDisabledReason:'coderegionDisableReason',
      parentField: 'deploymentType',
      loadInitialWithoutParent: true,
      asyncSelect: true,
      enabledWhen: {
        op: 'and',
        rules: [
          { field: 'is_yaml_sent', values: [0, null, undefined, false, '0'] },
          { field: 'deploymentExists', values: [false, null, undefined] },
        ],
      },
      options:[],
    },
    {
      attributeName: 'status_live',
      type: FormInputTypes.TEXT,
      label: 'StatusLive',
      default:'not_connected',
      hidden:true,
      required: true,
    },
    {
      attributeName: 'status_cloud',
      type: FormInputTypes.TEXT,
      label: 'StatusCloud',
      default:'not_connected',
      hidden:true,
      required: true,
    },
    {
      attributeName: 'status_ingest',
      type: FormInputTypes.TEXT,
      label: 'StatusIngest',
      default:'not_connected',
      hidden:true,
      required: true,
    },
    {
      attributeName: 'liveManifestName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Live manifest name',
      label: 'Live Manifest Name',
      default:'live',
      required: true,
      helpText: 'Name without extension of the manifest file that will be used for teh live streams of the deployment.',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'ott'},
    },
    {
      attributeName: 'applicationName',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'application name',
      label: 'Application Name',
      default:'live',
      required: true,
      helpText: 'Name without extension of the application Name that will be used for teh live low latency streams of the deployment.',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'manifestDelay',
      label: 'Manifest delay',
      helpText: 'In seconds. The number of seconds the manifest file starting time will be delayed. It is a good idea to introduce some delay to compensate for fluctuations in the end-to-end processing speed of the environment.',
      default: '10',
      type: FormInputTypes.SELECT,
      options: [
        { name: '0 sec', value: 0 },
        { name: '10 sec', value: 10 },
        { name: '15 sec', value: 15 },
        { name: '20 sec', value: 20 },
        { name: '30 sec', value: 30 },
        { name: '60 sec', value: 60 },
      ],
      visibleWhen:{"field":"deploymentType","value":'ott'},

    },
    {
      attributeName: 'hlsManifestEnabled',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'HLS Manifest Enabled',
      label: 'HLS Manifest Enabled',
      required: true,
      default:false,
      helpText: 'Enable HLS manifest generation.',
      errorText: '',
      enabledWhen:{"field":"status_cloud","values":["not_connected","stopped","down","forced_stop"]},
      visibleWhen:[{"field":"deploymentType","value":'ott'},{"field":"deploymentHLSEnable","value":true}],

    },
    {
      attributeName:"sepBackendAgent1",
      type:FormInputTypes.SEPARATOR,
      visibleWhen:[{"field":"backendAgentMode","value":true}],

    },
    {
      attributeName: 'backendAgentMode',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Use cloud or not when launching live event',
      label: 'Backend Agent Mode',
      required: true,
      default:false,
      helpText: 'Enable cloud or not.',
      errorText: '',
      disabled:true,
      visibleWhen:[{"field":"backendAgentMode","value":true}],

    },
    {
      attributeName: 'liveBackendEndPoint',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'LiveBackend endpoint found',
      label: 'LiveBackendEndPoint',
      default:'',
      required: true,
      helpText: 'LiveBackend endpoint found',
      errorText: '',
      disabled:true,
      visibleWhen:[{"field":"backendAgentMode","value":true}],
    },
    {
      attributeName: 'makeBackwardCompatible',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Use cloud or not when launching live event',
      label: 'Make backward compatible',
      required: true,
      default:false,
      helpText: 'If true we use the traditional way to manage the agents R26 and earlier.',
      errorText: '',
      visibleWhen:[{"field":"backendAgentMode","value":true}],
    },
    {
      attributeName: 'makeBackwardCompatibleStaticText',
      type: FormInputTypes.STATIC_TEXT,
      placeholder: 'LiveBackend endpoint found',
      label:"NOTE!",
      default:'If you use the backward compatible option, bla bla bla bla this text should be a long text, for the ops team to know what the hell is this checkbox doing here, and what is that for',
      required: true,
      errorText: '',
      disabled:true,
      visibleWhen:[{"field":"makeBackwardCompatible","value":true}],
      classCss:'form-show-text__important',
      classCssLabel:'form-show-text__bold'
    },
    {
      attributeName:"sepBackendAgent2",
      type:FormInputTypes.SEPARATOR,
      visibleWhen:[{"field":"backendAgentMode","value":true}],

    },
    {
      attributeName: 'viewgenLifeCycle',
      label: 'viewgen Life Cycle',
      helpText: 'LifeCycle options.',
      default: 'spot',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Spot', value: 'spot' },
        { name: 'On Demand', value: 'onDemand' },
      ],
    },
    {
      attributeName: 'cloudEnabled',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Use cloud or not when launching live event',
      label: 'Cloud enabled',
      required: true,
      default:true,
      helpText: 'Enable cloud or not.',
      errorText: '',
      enabledWhen:{"field":"status_cloud","values":["not_connected","stopped","down","forced_stop"]},

    },
  
    {

      attributeName: 'timeshift',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Timeshift',
      label: 'Timeshift Enabled',
      required: true,
      default:false,
      helpText: 'Enable timeshifting on live event.',
      errorText: '',
      confirmPopup:true,
      confirmText:"Are you sure you want to change timeshift, the resources needed are much higher if it is on?",
      enabledWhen:{"field":"status_ingest","values":["not_connected","stopped","forced_stop"]},
      visibleWhen:[{"field":"deploymentType","value":'ott'},{"field":"deploymentTimeshift","value":true}],
    },
    {
      attributeName: 'drm',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'DRM',
      label: 'DRM Enabled',
      required: true,
      default: false,
      helpText: 'Enable DRM.',
      errorText: '',
      enabledWhen:{"field":"status_ingest","values":["not_connected","stopped","forced_stop"]},
      visibleWhen:{"field":"deploymentType","value":'ott'},
    },
    {
      attributeName: "drm_provider",
      type: FormInputTypes.SELECT,
      label: "DRM provider",
      helpText: "Provide drm provider",
      default: "",
      visibleWhen:[{"field":"drm","value":true}],
      options: [
        { name: 'Clear key', value:'clearkey' },
        { name: 'Axinom', value:'axinom' }
      ],
    },
    // {
    //   attributeName: 'liveScheduledEnabled',
    //   type: FormInputTypes.CHECKBOX,
    //   placeholder: 'To use this live with live scheduled providers.',
    //   label: 'Remote Controller Enabled',
    //   default:false,
    //   helpText: 'To use this live with live scheduled providers linked to the live remote controller.',
    //   errorText: '',
    // },
     {
      attributeName: 'isLiveContinuous',
      type: FormInputTypes.CHECKBOX,
      placeholder: 'Inform livebackend as live continuous.',
      label: 'Is Live Continuous',
      default:false,
      helpText: 'Inform livebackend as live continuous.',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'ott'},
    },

    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'endpointProtocol',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Ingest Endpoint protocol',
      label: 'Ingest Endpoint protocol',
      default:'rtmp',
      required: true,
      helpText: 'Set the ingest endpoint protocol (Eg. rtmp).',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'endpointServer',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Ingest Endpoint server',
      label: 'Ingest Endpoint server',
      default:'',
      required: true,
      helpText: 'Set the ingest endpoint server host (Eg. 55.22.22.22).',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'endpointPort',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Ingest Endpoint port',
      label: 'Ingest Endpoint port',
      default:'1935',
      required: true,
      helpText: 'Set the ingest endpoint port (Eg. 1935).',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'publicEndpointProtocol',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Public Endpoint protocol',
      label: 'Public Endpoint protocol',
      default:'rtmp',
      required: true,
      helpText: 'Set the public endpoint protocol (Eg. rtmp).',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'publicEndpointServer',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Public Endpoint server',
      label: 'Public Endpoint server',
      default:'',
      required: true,
      helpText: 'Set the public endpoint server host (Eg. 55.22.22.22).',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    {
      attributeName: 'publicEndpointPort',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Public Endpoint port',
      label: 'Public Endpoint port',
      default:'1935',
      required: true,
      helpText: 'Set the public endpoint port (Eg. 1935).',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
     {
      attributeName: 'clientAutoscaling',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      placeholder: 'Client Autoscaling',
      label: 'Client Autoscaling',
      default:0,
      required: true,
      helpText: 'Set the value for autoscaling.',
      errorText: '',
      visibleWhen:{"field":"deploymentType","value":'lowLatency'},
    },
    // {
    //   attributeName: 'deploymentType',
    //   type: FormInputTypes.TEXT_INPUT.TEXT,
    //   placeholder: 'd',
    //   label: 'Deployment type',
    //   default:'',
    //   required: true,
    //   helpText: 'Set the endpoint port (Eg. 1935).',
    //   errorText: ''
    // },
  ],
};
